export default __webpack_public_path__ + "static/media/744.074f234e.png";